import styled from 'styled-components'
import { COLORS } from '../../../../Utils/colors'

export const IconStyle = (props) => {
    let Style = null
    switch (props.type) {
        case 'disabled':
            Style = styled.div`
                position: relative;
                color: #D6E1E8;
                font-size: ${props.size || '21px'};
            `
            return <Style>{props.children}</Style>

        case 'hover':
            Style = styled.div`
                color: #A5A5A5;
                position: relative;
                transition: .2s;
                cursor: pointer;
                font-size: ${props.size || '21px'};
                svg {
                    fill: #A5A5A5;
                    transition: .2s;
                }
                &:hover {
                    color: ${COLORS.deepBlue};
                    svg {
                        fill: ${COLORS.deepBlue};
                    }
                }
                
            `
            break;

        case 'active':
            Style = styled.div`
                color: ${COLORS.deepBlue};
                position: relative;
                transition: .2s;
                filter: drop-shadow(0 0 0 rgba(56,153,236,.0));
                cursor: pointer;
                font-size: ${props.size || '21px'};
                &:hover {
                    filter: drop-shadow(0 1px 5px rgba(56,153,236,.8))
                }
            `
            break;
        case 'active-not-hover':
            Style = styled.div`
                        color: ${COLORS.deepBlue};
                        position: relative;
                        transition: .2s;
                        filter: drop-shadow(0 0 0 rgba(56,153,236,.0));
                        cursor: pointer;
                        font-size: ${props.size || '21px'};
                        svg {
                            fill: ${COLORS.deepBlue};
                        }
                    `
            break;
        default:
            Style = styled.div`
                color: #A5A5A5;
                position: relative;
                transition: .2s;
                cursor: pointer;
                font-size: ${props.size || '21px'};
                    &:hover {
                        color: ${COLORS.deepBlue};
                    }
            `
    }

    
    return <Style style={props.style} id={props.id} onClick={e => {props.onClick(e)}} onMouseOver={props.onMouseOver} onMouseLeave={props.onMouseLeave} >{props.children}</Style>
}